import React, { memo, useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { steps } from '../constants/configuration';
import ServiceWrapper from './serviceWrapper';
import styles from '../styles/configuration.module.scss';
import { Dropdown } from 'react-dropdown-now';
import 'react-dropdown-now/style.css';

function NetworkConfig({ service, changeConfigurations, intialConfigs }) {
    const { t } = useTranslation('configuration');
    const initialOptions = {};
    const [options, setOptions] = useState(intialConfigs);
    const [isMount, setIsMount] = useState(false);
    const [isHidden, setIsHidden] = useState(true);
    const [value, setValue] = useState(0);

    useEffect(() => {
        if (isMount) {
            changeConfigurations({ ...options });
            setValue(value === 3 ? findValue() : checkIfCustom());
        }
    }, [options]);

    const checkIfCustom = () => {
        let futureStep = value;
        service.options.forEach(option => {
            if (option.min !== undefined && options[option.title] !== option[steps[value]]) {
                futureStep = 3;
                return;
            }
        });

        return futureStep;
    };

    const findValue = () => {
        let degreeIndex = '';
        const initialValue = service.options[0];
        steps.forEach((step, index) => {
            if (initialValue[step] === options[initialValue.title]) {
                degreeIndex = index;
                return;
            }
        });

        service.options.forEach(option => {
            if (option.min && options[option.title] !== option[steps[degreeIndex]]) {
                degreeIndex = 3;
                return;
            }
        });

        return degreeIndex;
    };

    useEffect(() => {
        if (isMount && value !== 3) {
            service.options.forEach(option => {
                if (option.title) {
                    initialOptions[option.title] = option[steps[value]];
                }
            });
            setOptions(initialOptions);
        }
    }, [value]);

    useEffect(() => {
        setIsMount(true);
    }, []);

    return (
        <ServiceWrapper service={service} preset={value} changePreset={newValue => newValue !== 3 && setValue(newValue)}>
            <div className={'flex ' + styles.configs} onClick={() => setIsHidden(!isHidden)}>
                <div className={styles['arrow-container']}>
                    <div className={`${styles['arrow-element']} ${isHidden ? '' : styles['rotate-forward']}`} />
                </div>
                <p className={'pointer ' + styles.title}>{t('config')}</p>
            </div>
            <div className={`${styles[isHidden ? 'hide' : 'visible']} ${styles.options}`}>
                {service.options.map((option, key) => (
                    option.title && <div className={styles['config-wrapper']} key={key}>
                        <p className={(option.values ? '' : 'pointer ') + styles.content} style={{ width: 'calc(100% - 130px)' }}>{t(`${service.title.toLowerCase()}.${option.title}`)}</p>
                        {option.values ?
                            <Dropdown
                                options={option.values}
                                onChange={(e) => setOptions(prevState => ({ ...prevState, [option.title]: e.value }))}
                                value={options[option.title]}
                                className={styles['dropdown-size']}
                            />
                            : <input checked={options[option.title]} className='pointer' onChange={e => setOptions(prevState => ({ ...prevState, [option.title]: !prevState[option.title] }))} type="checkbox" />}
                    </div>
                ))}
            </div>
            <style jsx>{`
                select {
                    width: 70px;
                }
            `}</style>
        </ServiceWrapper>
    )
};

export default memo(NetworkConfig);
